module.exports = __webpack_public_path__ + "static/media/IG_square_TEMPLATE4.28ffe830.png";